// as soon as DOM is ready, relocate the cropper modal
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('image-cropper-popup');
  if (modal && modal.closest('form')) {
    // move it to be a direct child of <body>
    document.body.appendChild(modal);
  }
});

document.querySelectorAll('.wishlist-button').forEach(button => {
    button.addEventListener('click', function() {
        // Make sure there's a container for the hearts
        let heartContainer = this.querySelector('.heart-container');
        if (!heartContainer) {
            heartContainer = document.createElement('div');
            heartContainer.classList.add('heart-container');
            this.appendChild(heartContainer);
        }

        for (let i = 0; i < 10; i++) {
            let heart = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            heart.classList.add('heart');
            heart.setAttribute("viewBox", "0 0 131.27 90.18");
            heart.innerHTML = '<path d="M60.83,17.18c8-8.35,13.62-15.57,26-17C110-2.46,131.27,21.26,119.57,44.61c-3.33,6.65-10.11,14.56-17.61,22.32-8.23,8.52-17.34,16.87-23.72,23.2l-17.4,17.26L46.46,93.55C29.16,76.89,1,55.92,0,29.94-.63,11.74,13.73.08,30.25.29c14.76.2,21,7.54,30.58,16.89Z"/>';

            const size = Math.random() * (30 - 10) + 10;
            heart.style.width = `${size}px`;
            heart.style.height = `${size}px`;
            heart.style.left = `${Math.random() * (this.offsetWidth - size)}px`;
            heart.style.setProperty('--translateX', `${Math.random() * 100 - 50}px`);

            heartContainer.appendChild(heart);

            setTimeout(() => {
                heart.style.animation = `floatAndFade ${2 + Math.random() * 2}s ease-out forwards`;
            }, i * 100);

            setTimeout(() => {
                heart.remove();
            }, 4000);
        }
    });
});


const helpers = {
  dollarify(rawValue) {
	return rawValue.toLocaleString("en-US", {style:"currency", currency:"USD"});
  },
  
  serialize(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
            '=' +
            encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  },

  fetchConfig(type = 'json') {
    return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  },

  scrollToTarget(target, offset = 120){
    var targetPosition = target.getBoundingClientRect().top;
    var offsetPosition = targetPosition + window.pageYOffset - offset;
    window.scrollTo({
       top: offsetPosition,
       behavior: "smooth"
    });
  }
}

const splideApp = {
  init () {
    this.selector = document.querySelector('#product-slider');
    if (!this.selector) return;
    this.setupSliders();
    this.mount();
  },

  setupSliders() {
      const productSlider = this.productSlider = new Splide ('#product-slider', {
        drag: true,
        arrows: false,
        pagination: false,
        speed: 800,
        cursor: 'grab',
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        perMove: 2,
        perPage: 1,
        flickPower: 300,
        flickMaxPages: 1,
        breakpoints: {
           768: {
             arrows: false,
             gap: 0,
             pagination: true
            }
          }
      });

      const productThumbnailSlider = this.productThumbnailSlider = new Splide ('#thumbnails-slider',  { 
        fixedWidth : 80,
        fixedHeight: 80,
        gap        : 8,
        rewind     : true,
        pagination : false,
        isNavigation: true,
        arrows: document.querySelectorAll('#thumbnails-slider img').length > 4,
        perPage: 1,
        direction: 'ttb',
        height: 352,
         breakpoints: {
           768:{
             direction: 'ltr'
           }
         }
      });

    const productPopupSlider = this.productPopupSlider = new Splide ('#product-popup-slider', {
        drag: true,
        arrows: true,
        pagination: true,
        speed: 800,
        cursor: 'grab',
        width: '50vw',
        height: '95vh',
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        perMove: 1,
        perPage: 1,
        flickPower: 300,
        flickMaxPages: 1,
        breakpoints: {
           768: {
             arrows: false,
             width: '100vw',
             gap: 0,
             pagination: true
            }
          }
      });



      productSlider.sync( productThumbnailSlider );
      productSlider.sync( productPopupSlider );
  },

  mount() {
    this.productSlider.mount();
    this.productThumbnailSlider.mount();
    this.productPopupSlider.mount();
  }
}

splideApp.init();

const productFormApp = {
  init() {
    console.log(this);
    this.quantityUpdaterWraps = document.querySelectorAll('.quantity-wrapper');
    if (!this.quantityUpdaterWraps.length) return;
    this.updaters = document.querySelectorAll('.qty-button');
  
    this.fields = document.querySelectorAll('#quantity');
    this.masterSelect = document.querySelector('#product-select');
    this.qty = 1;

    this.qtyMsgBox = document.querySelector('.quantity-msg');
    this.maxQtyBoard = this.qtyMsgBox.querySelector('.max-qty-board');
    
    this.setupEventListeners();
  },

  setupEventListeners() {
    this.updaters.forEach(updater => updater.onclick = this.handleUpdaterClick.bind(this, updater));    
    this.fields.forEach(field => field.oninput = this.handleFieldInput.bind(this));
    this.fields.forEach(field => field.onchange = this.handleFieldChange.bind(this));
  },

   handleFieldInput({ target }) {
    const { value } = target;
    const limit = parseInt(this.masterSelect.options[this.masterSelect.selectedIndex].dataset.quantity);
      this.maxQtyBoard.textContent = limit;
    if (value > limit){
      this.qty = limit;
      this.qtyMsgBox.classList.add('show');
    } else {
      this.qty = target.value;
      this.qtyMsgBox.classList.remove('show');
    }
     
    this.calculatePrice();
    this.render();
  },

  handleFieldChange({ target }) {
    const { value } = target;
    const limit = parseInt(this.masterSelect.options[this.masterSelect.selectedIndex].dataset.quantity);
    if (value > limit){
      this.qty = limit;
      this.qtyMsgBox.classList.add('show');
    } else if (!value) {
      this.qty = 1;
    }else {
      this.qty = target.value;
      this.qtyMsgBox.classList.remove('show');
    }
    this.calculatePrice();
    this.render();
  },

  calculatePrice() {
    const { masterSelect } = this;
    const individualPrice = parseInt(masterSelect.options[masterSelect.selectedIndex].dataset.price);
    this.price = individualPrice * this.qty;
  },

  handleUpdaterClick(u, e) {
    const field = u.closest('.quantity-wrapper').querySelector('input');
    const value = parseInt(field.value);
    switch(u.dataset.role){
      case 'increase':
        this.qty = parseInt(value) + 1; 
        break;
      case 'decrease':
        if (value > 1){
          this.qty = parseInt(value) - 1;
        }
        break;
      default:
        return;
    }

    this.calculatePrice();
    this.render();
    
    $(this.fields[0]).trigger('change');
  },

  // renderQtyBoxes() {
  //   this.fields.forEach(field => {
  //     field.value = this.qty
  //     field.tri
  //   });
  // },

  render() {
    this.fields.forEach(field => field.value = this.qty);
    const price = currencyFormatter(this.price / 100);
    const atcMoneyBoard = document.querySelector('#add-to-cart .money');
    if (atcMoneyBoard) atcMoneyBoard.textContent = price;
    const customSockAtcMoneyBoard = document.querySelector('#custom-sock-atc .money');
    if (customSockAtcMoneyBoard) customSockAtcMoneyBoard.textContent = price; 
  }
  
}

productFormApp.init();



const swatchApp = {
  init() {
    this.swatchInputs = document.querySelectorAll('.swatch-element input');
    if (!this.swatchInputs.length) return;
    this.select = document.querySelector('#product-select');
    this.productSlider = splideApp.productSlider;
    this.images = [...document.querySelectorAll('#product-slider-list img')];
    this.setupEvents();
  },

  setupEvents() {
    this.swatchInputs.forEach(input => input.onchange = this.handleSwatchChange.bind(this));
  },

  handleSwatchChange(e) {
    const variant = this.select.options[this.select.selectedIndex];
    const index = this.images.findIndex(image => {
      console.log({ img: image.src, var: variant.dataset.image })
      return image.src.includes(variant.dataset.image)
    });
    if (index < 0) return;
    this.productSlider.go(index);    

    productFormApp.qtyMsgBox.classList.remove('show');
    productFormApp.fields[0].value = 1;
    $(productFormApp.fields[0]).trigger('change');
    
  }
 
}

swatchApp.init();

(function stickyAtc () {
  
  function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId= setTimeout(function(){
    method();
    }, delay);
  }

  function handleScroll (event) {
    var height = $(window).height() - 200;
    var scroll = $(window).scrollTop();
    if(scroll > height){
     $(".sticky_cart").addClass("show");
    } else {
     $(".sticky_cart").removeClass("show");
    }
  }

  $(window).scroll(function() {
    debounce(handleScroll, 20);
  });
  
}());

const currencyFormatter = (price) => {
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: Shopify.currency.active,
  });

  return formatter.format(price);
}



const productPopupApp = {
  init() {
    this.productSliderPopup = document.querySelector('.product__visual-popup');
    if (!this.productSliderPopup) return;
    this.productSliderList = document.querySelector('#product-slider-list');
    this.productSingleImage = document.querySelector('.product__visual-single')
    this.closer = this.productSliderPopup.querySelector('.popup-close');
    console.log(this)
    this.setupEventListeners();
  },

  setupEventListeners() {
    if (this.productSliderList) this.productSliderList.onclick = this.showPopup.bind(this);
    if (this.productSingleImage) this.productSingleImage.onclick = this.showPopup.bind(this);
    this.closer.onclick = this.closePopup.bind(this);
  },

  showPopup() {
    this.productSliderPopup.classList.add('visible');
    document.body.classList.add('unscroll');
  },

  closePopup() {
    this.productSliderPopup.classList.remove('visible');
    document.body.classList.remove('unscroll');
  }
}

productPopupApp.init();


(function customSockBuilder() {
  const model = {
    init() {
      this.buttonHTML = `<span class="upload-icon"><img src="https://cdn.shopify.com/s/files/1/0023/0191/9345/files/upload-photo.png?v=1688315140" alt="Upload image icon" /></span><span class="photo-upload-block__text">Upload Photo</span>`;
      this.title = '1 Face';
      this.photos = [];
      this.validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      //active data 
      this.cropper = null;
      this.selectedImage = null;
      this.croppedImage = null;
      this.croppedImageDataURL = null;
      this.activeInput = null;
    },

    getFaces() {
      return this.faces;
    }
  }

  const controller = {
    init() {
      model.init();
      view.init();
      sliderView.init();
      cropperView.init();
    },

    getModel() {
      return model;
    },

    getViews() {
      return {
        view,
        sliderView, 
        cropperView
      };
    },

    getFaces() {
      return parseInt(model.title.split(' ')[0]);
    },

    setTitle(x){
      model.title = x;
      const faces = this.getFaces();
      model.photos = model.photos.slice(0, faces);
      view.render();
    },

    setCropper(cropper) {
      model.cropper = cropper; 
    },

    setSelectedImage(img) {
      model.selectedImage = img;
      cropperView.render();
    },
    
    setInitialPhotos(max) {
      model.photos = new Array(max).fill(null);
    },

    setActiveInput(node) {
      model.activeInput = node;
    },
    
    addPhoto(pos, src) {
      model.photos[pos] = src;
      view.render();
    },

    removePhoto(pos) {
      model.photos[pos] = null;
    },

    handleCropperAction(evt) {
      const currentTarget = evt.currentTarget;
      if (!currentTarget.matches('button')) return;
      switch(currentTarget.dataset.purpose) {
        case 'zoom-in':
          model.cropper.zoom(0.1);
          break;
        case 'zoom-out':
          model.cropper.zoom(-0.1);
          break;
        case 'rotate-clockwise':
          model.cropper.rotate(90);
          break;
        case 'rotate-anticlockwise': 
          model.cropper.rotate(-90);
          break;
        default: 
          console.error("Unidentified purpose")
      }
    },

    cropPhoto() {
      const croppedImageDataURL = model.cropper.getCroppedCanvas().toDataURL('image/png');
      cropperView.hideModal();
      this.addPhoto(parseInt(model.activeInput.dataset.index) - 1, croppedImageDataURL);
    },

    resetCrop() {
      model.cropper.reset();
    },

    dataURItoBlob(dataURI) {
      try {
        let [metadata, base64Data] = dataURI.split(',');
        let contentType = metadata.split(':')[1].split(';')[0];
        let byteString = atob(base64Data);
        let arrayBuffer = new ArrayBuffer(byteString.length);
        let uint8Array = new Uint8Array(arrayBuffer);
    
        for (let i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
        }
        
        // Create a Blob object using the binary data and content type
        return new Blob([uint8Array], { type: contentType });
      } catch (err) {
        console.error(err);
        return null;
      }
    },

    async addItemToCart(info) {
      const config = helpers.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      view.atc.classList.add('loading');
      view.atc.disabled = true;

      // function dataURItoBlob(dataURI) {
      //   const byteString = atob(dataURI.split(',')[1]);
      //   const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      //   const ab = new ArrayBuffer(byteString.length);
      //   const ia = new Uint8Array(ab);
      //   for (let i = 0; i < byteString.length; i++) {
      //       ia[i] = byteString.charCodeAt(i);
      //   }
      //   return new Blob([ab], { type: mimeString });
      // }
      
      if (info.form) {
        try {
          const formData = new FormData(info.form);
          config.body = formData;
          console.log({ formData })

          console.log(model.photos);
          
          model.photos.forEach((photo, index) => {
            if (!photo) return;
            
            const blob = this.dataURItoBlob(photo);
            if (blob instanceof Blob) {
              formData.append(`properties[Photo ${index + 1}]`, blob, 'photo.png');
            } else {
              formData.append(`properties[Photo ${index + 1}]`, '', 'photo.png');
            }
            // formData.append(`properties[Photo ${index + 1}]`, (this.dataURItoBlob(photo) ?? ''), 'photo.png');
          })


          let photoCountInFormdata = 0;
          for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
            if (key.startsWith('properties[Photo') && !!value) {
              photoCountInFormdata++;
            }
          }

          if(photoCountInFormdata != this.getFaces()){
            alert("Sorry, the uploaded photos do not match with selected number of faces. Please try again."); 
            return;
          }

          
          const res = await fetch('/cart/add.js', config);

          if (res.status == 400 || res.status == 504){
            console.error("Add Item To Cart Response " + res.status);
            alert("Sorry, this ran into an error. Please try again."); 
            return;
          }
          
          const json = await res.json();
          console.log({ pros: json.properties })
          const photoCountInRes = Object.keys(json.properties).reduce((acc, key) => {
            if (key.startsWith('Photo') && !!json.properties[key]) {
              return acc + 1;
            }
            return acc;
          }, 0);
          
          if (json.variant_title.includes(photoCountInRes.toString())){
            this.showCart();
          } else {
            // Fetch request to remove item from cart
            const removeItemConfig = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: `${json.key}`,
                quantity: 0
              })
            };
          
            const removeRes = await fetch('/cart/change.js', removeItemConfig);
          
            if (removeRes.status === 200) {
              alert('Sorry, failed to add to cart. Number of faces and images do not match!');
            } else if (removeRes.status == 400 || removeRes.status == 504) {
              alert('Some images did not upload. Please remove the item manually and try adding to cart once again!');
            }
            
            // this.showCart();

          }
        }
        catch(err) {
          console.error(err);
          alert("Sorry, this ran into an error. Please try again later."); 
        }
        finally {
          view.atc.classList.remove('loading');
          view.atc.disabled = false;
        }
      }
    },

    showCart() {
      if (Rebuy?.SmartCart){
        Rebuy.SmartCart.show();
      } else {
        window.location.href = '/cart';  
      }
    },

    runValidations() {
      const faces = this.getFaces();
      const photos = model.photos;
      const photosOfInterest = photos.slice(0, faces);
      console.log({ photosOfInterest, photos });
      
      if (photosOfInterest.every(p => p)){
        return true;
      } 
      alert(`Please upload ${photosOfInterest.length > 1 ? photosOfInterest.filter(x => !!!x).length + ' more photo(s)!' : 1 + ' photo!' } `);
      return false;
      // switch (faces) {
      //   case 1:
      //     if (photos[0]){
      //       return true;
      //     } else {
      //       // alert('Please upload 1 photo!');
      //       return false;
      //     }
      //   case 2:
      //     if (photos[0] && photos[1]) {
      //       return true
      //     } else {
      //       const uploaded = !!photos[0] + !!photos[1];
      //       // alert(`Please upload ${2 - uploaded} more photo(s)`);
      //       return false;
      //     }
      //   case 3: 
      //     if (photos.filter(x => !!x).length === 3){
      //       return true
      //     } else {
      //       // alert(`Please upload ${3 - photos.filter(x => !!x).length} more photo(s)`);
      //       return false;
      //     }
      //   }
    }
  }

  const view = {
    init() {
      this.atc = document.querySelector('#custom-sock-atc');
      if (!this.atc) return;
      this.form = this.atc.closest('form');
      this.variantRadios = [...document.querySelectorAll('.custom-sock__swatches input')];
      this.photoUploadContainer = document.querySelector('.photo-upload-blocks')
      this.photoInputs = document.querySelectorAll('.photo-upload-block input');
      this.photoUploadBlocks = document.querySelectorAll('.photo-upload-block');
      this.masterSelect = document.querySelector('#product-select');
      this.photoUploadInfoPopup = document.querySelector('#photo-upload-info');
      this.photoUploadInfoPopupTrigger = document.querySelector('#photo-upload-info-popup-trigger');
      
      controller.setInitialPhotos(this.photoUploadBlocks.length);
      this.setupEventListeners();
      this.curtainFalls();
    },

    setupEventListeners() {
      this.atc.addEventListener('click', this.handleAtcClick.bind(this));
      this.variantRadios.forEach(radio => radio.addEventListener('change', this.handleVariantRadioChange.bind(this)));
      this.photoUploadContainer.addEventListener('change', this.handleFileUpload.bind(this));
      this.photoUploadBlocks.forEach((block) => block.addEventListener('dragenter', this.handleUploadBlockDragEnter.bind(this, block)));
      this.photoUploadBlocks.forEach((block) => block.addEventListener('dragleave', this.handleUploadBlockDragLeave.bind(this, block)));
      this.photoUploadInfoPopupTrigger.addEventListener('click', this.showPhotoUploadInfoPopup.bind(this));
    },

    curtainFalls() {
      this.enableAddToCart();
      this.showFormView();
      const selectedVariantRadio = this.variantRadios.find(radio => radio.checked);
      if (selectedVariantRadio) {
        selectedVariantRadio.dispatchEvent(new Event('change'));
      }
    },

    enableAddToCart() {
      this.atc.disabled = false;
    },


    showFormView() {
      this.form.classList.remove('loading');
    },

    showPhotoUploadInfoPopup(e) {
      e.preventDefault();
      this.photoUploadInfoPopup.classList.add('visible');
      document.body.classList.add('unscroll');
    },

    handleAtcClick(e) {
      e.preventDefault();      
      const greenSignal = controller.runValidations();
      if (!greenSignal) {
        helpers.scrollToTarget(document.querySelector('#add-item-form'), 125);
        this.photoUploadBlocks.forEach(x => {
          if(!x.classList.contains('uploaded')){
            x.classList.add('highlight');
            setTimeout(() => {
              x.classList.remove('highlight');
            }, 2000)
          }
        })
        return;
      }
      const form = this.atc.closest('form');
      controller.addItemToCart({ form });
    },

    handleVariantRadioChange(e) {
      const { title } = e.target.dataset;
      controller.setTitle(title);
      if (!this.masterSelect || !productFormApp) return;
      this.masterSelect.value = e.target.value;
      productFormApp.calculatePrice();
      productFormApp.render();
    },

    handleFileUpload ({ target }) {
      if (!target.matches('input[type=file]')){
        return;
      }

      const { index } = target.dataset;
      controller.setActiveInput(target);
      const file = target.files[0];

      if (!file.type.startsWith('image/')) {
        alert('Invalid file format. Please select an image file.');
        target.value = ''; 
        return;
      }

      const maxSizeInBytes = 6 * 1024 * 1024;
      
      if (file.size > maxSizeInBytes) {
        alert('Please upload an image smaller than 6 MB.');
        target.value = ''; 
        return;
      }
      
      const reader = new FileReader();
      
      // reader.onload = function(fileObject) {
      //   const data = fileObject.target.result;
      //   controller.addPhoto(index - 1, data);
      // };

      reader.onload = (event) => {
        controller.setSelectedImage(event.target.result); 
      };
      
      reader.readAsDataURL(file);
      target.value = "";
    },

    handleUploadBlockDragEnter(block, e) {
      block.classList.add('activated');
      console.log({ block });
    },

    handleUploadBlockDragLeave(block, e) {
      block.classList.remove('activated');
    },

    render() {
      const { photos, title, buttonHTML } = controller.getModel();

      const faces = controller.getFaces();

      this.photoUploadBlocks.forEach((box, i) => {
        
        const photo = photos[i];
        const label = box.querySelector('label');
            
        if (i < faces) {
          box.classList.add('display-flex');
          const fileInput = box.querySelector('input');
          if (fileInput) {
            // fileInput.name = `properties[Photo ${i + 1}]`; 
          } else {
            // const inputGroup = box.querySelector('.input-group');
            // inputGroup.innerHTML += `<input type="file" class="visually-hidden" data-index="${i + 1}" id="photo-${i + 1}" name="properties[Photo ${i + 1}]" />`;
          }
          if (photo){
            const image = new Image();
            // box.classList.add('uploaded');
            // label.innerHTML = `<img src="${photo}" alt="" />`;
            // box.classList.add('uploaded');
            // box.classList.remove('activated');
            
            image.onload = function() {
              box.classList.add('uploaded');
              box.classList.remove('activated');
              label.innerHTML = '';
              label.appendChild(image);
            }
            
            image.src = photo;
          } else {
            label.innerHTML = buttonHTML;
            box.classList.remove('uploaded');          
            box.classList.remove('activated');
          }
        } else {
          box.classList.remove('display-flex');
          box.querySelector('input').name = '';  
          // box.querySelector('input').remove();  
          label.innerHTML = buttonHTML;
        }
      })
      // for (let i = 0; i < 3; i++){
      //   const box = this.photoUploadBlocks[i];
      //   const photo = photos[i];
      //   const label = box.querySelector('label');
            
      //   if (i < faces) {
      //     box.classList.add('display-flex');
      //     const fileInput = box.querySelector('input');
      //     if (fileInput) {
      //       fileInput.name = `properties[Photo ${i + 1}]`; 
      //     } else {
      //       // const inputGroup = box.querySelector('.input-group');
      //       // inputGroup.innerHTML += `<input type="file" class="visually-hidden" data-index="${i + 1}" id="photo-${i + 1}" name="properties[Photo ${i + 1}]" />`;
      //     }
      //     if (photo){
      //       const image = new Image();
      //       image.src = photo;
      //       // box.classList.add('uploaded');
      //       // label.innerHTML = `<img src="${photo}" alt="" />`;
      //       // box.classList.add('uploaded');
      //       // box.classList.remove('activated');
            
      //       image.onload = function() {
      //         box.classList.add('uploaded');
      //         box.classList.remove('activated');
      //         label.innerHTML = '';
      //         label.appendChild(image);
      //       }
      //     } else {
      //       label.innerHTML = buttonHTML;
      //     }
      //   } else {
      //     box.classList.remove('display-flex');
      //     box.querySelector('input').name = '';  
      //     // box.querySelector('input').remove();  
      //     label.innerHTML = buttonHTML;
      //   }
      // }

      // photos.forEach((photo, index) => {
      //   const box = this.photoUploadBlocks[index];
      //   const image = new Image();
      //   if (photo){
      //     image.src = photo;
      //       image.onload = function() {
      //         box.classList.add('uploaded');
      //         const label = box.querySelector('label');
      //         label.innerHTML = '';
      //         label.appendChild(image);
      //     }
      //   } else {
      //     label.innerHTML = 'Upload photo';
      //   }
      // })
    }
  }

  const sliderView = {
    init () {
      this.colorRadios = document.querySelectorAll('.custom-sock__color input[type=radio]');
      if (!this.colorRadios.length) return;
      this.images = [...document.querySelectorAll('.product__slider .product__img')];
      this.slider = splideApp.productSlider;
      this.setupEventListeners();
    },

    setupEventListeners() {
      this.colorRadios.forEach(color => color.addEventListener('input', this.handleColorRadioChange.bind(this)));
    },

    handleColorRadioChange(e) {
      let index = this.images.findIndex(x => x.alt === e.target.value);
      if (index === -1){
        index = this.images.findIndex(x => x.src.includes(e.target.dataset.value)); 
      }
      this.slider.go(index);
    }
  }

  function showModal() {
      const modal = document.getElementById("warningModal");
      const closeButton = modal.querySelector(".close-button");
  
      // Display the modal
      modal.style.display = "flex";
  
      // Close modal when the close button is clicked
      closeButton.onclick = function() {
          modal.style.display = "none";
      };
  
      // Close modal when clicking outside of the modal content
      window.onclick = function(event) {
          if (event.target === modal) {
              modal.style.display = "none";
          }
      };
  }
  
  function resizeAndAddPadding(src, padding = 0) {
      return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = () => {
              // Check if the image dimensions are too small
              if (img.width < 300 || img.height < 300) {
                  showModal(); // Show the warning modal
              }
  
              // Determine if resizing is needed based on max dimension
              const MAX_SIZE = 1200;
              const needsResize = img.width > MAX_SIZE || img.height > MAX_SIZE;
  
              // Create a canvas to either resize or keep original dimensions
              const canvas = document.createElement('canvas');
              const context = canvas.getContext('2d');
  
              if (needsResize) {
                  const scaleFactor = Math.min(MAX_SIZE / img.width, MAX_SIZE / img.height);
                  canvas.width = img.width * scaleFactor;
                  canvas.height = img.height * scaleFactor;
                  context.drawImage(img, 0, 0, canvas.width, canvas.height);
              } else {
                  // Keep original dimensions if resizing isn't needed
                  canvas.width = img.width;
                  canvas.height = img.height;
                  context.drawImage(img, 0, 0);
              }
  
              // Convert the image to a Data URL (PNG or JPEG)
              const resizedSrc = canvas.toDataURL("image/png");
  
              // Proceed to add padding using the resized or original-sized image
              const paddedImage = new Image();
              paddedImage.src = resizedSrc;
              paddedImage.onload = () => {
                  const paddingX = paddedImage.width * padding;
                  const paddingY = paddedImage.height * padding;
  
                  const finalCanvas = document.createElement('canvas');
                  const finalContext = finalCanvas.getContext('2d');
  
                  // Set final canvas size with padding
                  finalCanvas.width = paddedImage.width + paddingX * 2;
                  finalCanvas.height = paddedImage.height + paddingY * 2;
  
                  finalContext.fillStyle = 'rgba(0, 0, 0, 0)';
                  finalContext.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
  
                  // Draw the image with padding
                  finalContext.drawImage(paddedImage, paddingX, paddingY);
                  resolve(finalCanvas.toDataURL());
              };
  
              paddedImage.onerror = reject;
          };
          
          img.onerror = reject;
      });
  }



  const cropperView = {
      init() {
          this.cropperModal = document.querySelector('#image-cropper-popup');
          this.setupEventListeners();
      },
  
      setupEventListeners() {
          this.cropperModal.querySelectorAll('button').forEach(btn => btn.addEventListener('click', this.handleActionButtonClick.bind(this)));
          this.cropperModal.querySelector('#cropper-crop-button').addEventListener('click', this.handleCrop.bind(this));
          this.cropperModal.querySelector('#cropper-reset-button').addEventListener('click', this.handleReset.bind(this));
      },
  
      showModal() {
          this.cropperModal.open();
      },
  
      hideModal() {
          this.cropperModal.close();
      },
  
      handleActionButtonClick(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          controller.handleCropperAction(evt);
      },
      
      handleCrop(event) {
          event.preventDefault();
          event.stopPropagation();
          controller.cropPhoto();
      },
      
      handleReset(event) {
          event.preventDefault();
          event.stopPropagation();
          controller.resetCrop();
      },
  
      render() {
          const { cropper, selectedImage } = controller.getModel();
          if (!selectedImage) {
              this.hideModal();
              return;
          };

          const container = this.cropperModal.querySelector('.cropper-container');
          
          // Clean up previous cropper instance
          if (cropper) {
              cropper.destroy();
          }
          
          // Clear container
          container.innerHTML = '';

  


          resizeAndAddPadding(selectedImage, 0.10) // Set padding as needed
              .then((paddedImageSrc) => {
                  const imageEl = document.createElement('img');
                  imageEl.src = paddedImageSrc;
                  container.appendChild(imageEl);
          
                  this.showModal();
          
                  if (cropper) {
                      cropper.destroy();
                  }
          
                  // Initialize Cropper.js on the padded image
                  controller.setCropper(new Cropper(imageEl, {
                      viewMode: 1,
                  }));
              })
              .catch(error => console.error("Error adding padding:", error));
        
                  
      }
  };


  controller.init();

})()

class CustomPopup extends HTMLElement {
  constructor() {
    super();
    this.popupCloseButton = this.querySelector('.popup-close');
    const triggerSelector = this.getAttribute('trigger-selector');
    this.triggers = triggerSelector ? document.querySelectorAll(triggerSelector) : []; 
    this.setupEvents();
  }



  setupEvents() {
      if (this.popupCloseButton) {
          this.popupCloseButton.addEventListener('click', this.close.bind(this));
          // Add touch event support
          this.popupCloseButton.addEventListener('touchend', (e) => {
              e.preventDefault();
              this.close();
          });
      }
      
      // Handle backdrop clicks/touches
      this.addEventListener('click', (e) => {
          if (e.target === this) {
              this.close();
          }
      });
      
      // Add touch support for backdrop
      this.addEventListener('touchend', (e) => {
          if (e.target === this) {
              e.preventDefault();
              this.close();
          }
      });
  }
  
  
  open(e) {
    this.classList.add('visible');
    document.body.classList.add('unscroll');
    if (e) {
      console.log({
        target: e.target,
        currentTarget: e.currentTarget
      })
      this.triggerData = e.target.dataset;
    }
    if (this.onOpen) {
      this.onOpen(e);
    }
  }
  
  close(e) {
    if (e) e.preventDefault();
    this.classList.remove('visible');
    document.body.classList.remove('unscroll');
  }
}

customElements.define('custom-popup', CustomPopup);


// class CustomPopup extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     const triggerSelector = this.getAttribute('trigger-selector');
//     this.triggers = triggerSelector ? document.querySelectorAll(triggerSelector) : [];  
//     this.popupCloseButton = this.querySelector('.popup-close');
//     this.setupEventListeners();
    
//   }

//   setupEventListeners() {
//     this.popupCloseButton.addEventListener('click', this.close.bind(this));
//     this.addEventListener('click', (e) => {
//       if (e.target === this){
//         this.close();
//       }
//     })
    
//     this.triggers.forEach(trigger => trigger.addEventListener('click', this.open.bind(this)));

//   }

//   open(e) {
//     this.classList.add('open');
//     document.body.classList.add('unscroll');
//     if (e) {
//       console.log({
//         target: e.target,
//         currentTarget: e.currentTarget
//       })
//       this.triggerData = e.target.dataset;
//     }
//     if (this.onOpen) {
//       this.onOpen(e);
//     }
//   }

//   close(e) {
//     if (e) e.preventDefault();
//     this.classList.remove('open');
//     document.body.classList.remove('unscroll');
//     if (this.onClose) {
//       this.onClose();
//     }
//   }
// }

// customElements.define('custom-popup', CustomPopup);

